import { Outlet } from "react-router-dom";

import useAuth from "../hooks/useAuth";

import NotFound from "../errors/NotFound";

const RequireAdmin = () => {
  const { auth } = useAuth();

  if (auth?.customer?.isAdmin) {
    return <Outlet />;
  }

  return <NotFound />;
};

export default RequireAdmin;
